// Public business contacts approved by the founder. Never include credentials.
export const LANDING_CONTACT = {
  email: 'anthony@ristodaily.com',
  whatsappNumber: '+393481997967',
};

export function demoContactLinks(contact = LANDING_CONTACT) {
  return contactLinks(contact, 'Richiesta demo RistoDaily', 'Buongiorno, vorrei conoscere RistoDaily e richiedere una demo per il mio ristorante.');
}

export function supportContactLinks(contact = LANDING_CONTACT) {
  return contactLinks(contact, 'Assistenza menù RistoDaily', 'Buongiorno, ho bisogno di assistenza con il menù RistoDaily.');
}

export function problemContactLinks(section, description, contact = LANDING_CONTACT) {
  const area = String(section || 'App').slice(0, 100);
  const problem = String(description || '').trim().slice(0, 1200);
  return contactLinks(contact, 'Segnalazione problema RistoDaily', `Segnalazione RistoDaily\nSezione: ${area}\n\n${problem}`);
}

function contactLinks(contact, title, text) {
  const email = typeof contact?.email === 'string' ? contact.email.trim() : '';
  const phone = typeof contact?.whatsappNumber === 'string' ? contact.whatsappNumber.trim() : '';
  const subject = encodeURIComponent(title);
  const message = encodeURIComponent(text);
  return {
    email: /^[^\s@?&#]+@[^\s@?&#]+\.[^\s@?&#]+$/.test(email)
      ? { label: email, href: `mailto:${email}?subject=${subject}&body=${message}` } : null,
    whatsapp: /^\+[1-9]\d{7,14}$/.test(phone)
      ? { label: phone, href: `https://wa.me/${phone.slice(1)}?text=${message}` } : null,
  };
}
